function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.465,
    height: 48,
    viewBox: "0 0 38.465 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47706",
    d: "M47.434 30.614a40.478 40.478 0 0 0 .833-6.2c.9-17.745-11.4-16.9-11.4-16.9C21.879 8.029 25.819 28.7 25.819 28.7l1.545 8.882h18.615z",
    transform: "translate(-20.413 -7.508)",
    style: {
      fill: "#a04c17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47707",
    d: "m23.381 73.67-.055.008a10.51 10.51 0 0 0-8.869 9.648l-.73 10.238H37.71V73.672z",
    transform: "translate(-13.727 -45.564)",
    style: {
      fill: "#6984bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47708",
    d: "M50.047 67.533a14.982 14.982 0 0 1-6.8 5.756 14.982 14.982 0 0 1-6.8-5.756c2.545-.782 3.56-2.37 3.483-4.533l3.314.769L46.563 63c-.076 2.162.937 3.751 3.484 4.533z",
    transform: "translate(-26.799 -39.427)",
    style: {
      fill: "#f7c684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47709",
    d: "M92.96 47.34h2.34v11.615h-2.34z",
    transform: "translate(-61 -30.419)",
    style: {
      fill: "#ffb22a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47710",
    d: "M98.48 47.34h2.345v11.615H98.48z",
    transform: "translate(-64.175 -30.419)",
    style: {
      fill: "#e17f29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47711",
    d: "M60.306 73.674H78.65a2.124 2.124 0 0 1 2.124 2.126v14.789H58.182V75.8a2.124 2.124 0 0 1 2.124-2.126z",
    transform: "translate(-43.545 -45.566)",
    style: {
      fill: "#81a1b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47712",
    d: "M77.363 116.467H58.247a2.974 2.974 0 0 1-2.974-2.974h25.064a2.974 2.974 0 0 1-2.974 2.974z",
    transform: "translate(-41.872 -68.47)",
    style: {
      fill: "#65828b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47713",
    d: "M49.787 27.981v5.272a7.532 7.532 0 1 1-15.064 0v-5.272s6.992-2.162 7.532-4.941a10.817 10.817 0 0 0 7.532 4.941z",
    transform: "translate(-25.804 -16.442)",
    style: {
      fill: "#ffd18b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47715",
    d: "M83.8 89.857a2.752 2.752 0 1 1-2.752-2.751 2.752 2.752 0 0 1 2.752 2.751z",
    transform: "translate(-55.113 -53.292)",
    style: {
      fill: "#add3d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47716",
    d: "m97.651 41.669-2.344-4.189-2.345 4.189z",
    transform: "translate(-61.002 -24.748)",
    style: {
      fill: "#ffd18b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigner);
export default __webpack_public_path__ + "static/media/designer.a2901f27ca1f203497e99cbab2f7ef84.svg";
export { ForwardRef as ReactComponent };